import { Component, Inject } from "@angular/core";
import { AppLoaderService } from "../../../../services/app-loader/app-loader.service";
import { LicenseService } from "../../../services/LicenseService";
import { MD_DIALOG_DATA, MdDialogRef } from "@angular/material";
import { Router } from "@angular/router";
import { AdalService } from "../../../shared/adal.service";

@Component({
    selector:'smartlink360-view-feedback',
    template:require('./smartlink360-view-feedback.component.html'),
    styles:[require('./smartlink360-view-feedback.component.css')]
})
export class SmartLink360ViewFeedbackComponent{
    dialogTitle='View Feedback';
    errorMessage='';
    SelectedDemoLicenseInfo;
    feedbackDetails;
    error='';
    selectedRow=null;
    isLoading=false;
    constructor(
        private appLoader:AppLoaderService,
        private licenseService:LicenseService,
        private dialogRef:MdDialogRef<SmartLink360ViewFeedbackComponent>,
        private adalService:AdalService,
        private router:Router,
        @Inject(MD_DIALOG_DATA) public dialogData:any,
    ){
        if (!this.adalService.getCachedToken()) {
            this.dialogRef.close(null);
            this.router.navigate(["login"]);
        }
        this.SelectedDemoLicenseInfo=dialogData.SelectedLicenseDetail
        this.getFeedbackDetails()
    }
    selectRow(index){
        this.selectedRow=this.selectedRow==index?null:index
    }
    getFeedbackDetails(){
        this.isLoading=true;
        this.licenseService.getUserFeedBackInfo(this.SelectedDemoLicenseInfo.UserRegId).subscribe((data)=>{
            if(!data.IsError && data.DataObject !=null){
                this.feedbackDetails=data.DataObject;
            }
            else{
                this.error=data.Error;
            }
            this.isLoading=false;
        })
    }
    onCancel(){
        this.dialogRef.close()
    }
}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/license-portal/smartlink360/smartlink360-view-feedback/smartlink360-view-feedback.component.ts